const e=["normal","start","end","both"],r={trim:{type:"enum",className:"rt-r-lt",values:e,responsive:!0}};export{r as leadingTrimPropDef};
//# sourceMappingURL=leading-trim.prop.js.map
